const postMessageToTarget = (scope, message) => {
  return new Promise((resolve, reject) => {
    let target = window.parent
    if (!target || !target.postMessage) return resolve(false)
    // var trustedOrigin = window.parent
    target.postMessage({ scope, message }, '*')
    resolve(true)
  })
}

export const resized = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    var box = document.querySelector('#app')
    let currentHeight = box.clientHeight
    if (!currentHeight || state.height === currentHeight) resolve()
    commit('SET_HEIGHT', currentHeight)
    postMessageToTarget('altura', { height: currentHeight })
    .then(() => {
      resolve()
    })
  })
}
